import {
  COUNT_CREATIVES_LOAD_PER_PAGE,
  MAX_PAGINATION_PAGE,
} from '@/common/constants/count'
import { CANCELED_REQUEST } from '@/common/constants/responseCodes'

export const searchHydrate = ({ state, action, slice }) => {
  const { [slice]: data } = action.payload

  if (data.filtersConfig && data.filtersConfigMap) {
    state.filtersConfig = data.filtersConfig
    state.filtersConfigMap = data.filtersConfigMap ?? {}
  }

  if (!state.filtersParams) {
    state.filtersParams = data.filtersParams
  }

  state.selectedItem = data.selectedItem
}

export const fetchItemsPending = (state) => {
  state.isLoadingItems = true
  state.isErrorLoadingItems = null
  state.needFetchCreatives = false
  state.errorId = ''
}

export const fetchItemsSuccess = (state, { payload }) => {
  const currentPage = payload.pagination.pages.current
  const limit = payload.pagination.pages.limit
  const totalPages =
    payload.pagination.pages.total > MAX_PAGINATION_PAGE
      ? MAX_PAGINATION_PAGE
      : payload.pagination.pages.total || 1

  if (state.isInfiniteScroll && payload.withInfiniteScroll) {
    state.items = [...state.items, ...payload.items]
    const lastPage = Object.keys(state.pagesMap)[
      Object.keys(state.pagesMap).length - 1
    ]
    const lastItemOnPage = state.pagesMap[lastPage]?.index?.last || limit - 1
    const firstCreative = lastItemOnPage + 1
    const lastCreatives = lastItemOnPage + payload.items.length

    state.pagesMap[currentPage] = {
      page: currentPage,
      index: {
        start: firstCreative,
        last: lastCreatives,
      },
    }
  } else {
    state.pagesMap = {}
    state.pagesMap[currentPage] = {
      page: currentPage,
      index: {
        start: 0,
        last: payload.items.length - 1,
      },
    }
    state.items = payload.items
  }

  state.pagination = {
    ...state.pagination,
    limit: payload.pagination.pages.limit,
    total: totalPages,
    totalPages: payload.pagination.pages.total || 1,
    totalItems: payload.pagination.results.total,
  }

  state.isLoadingItems = false
}

export const fetchItemsRejected = (state, { payload }) => {
  if (payload?.code !== CANCELED_REQUEST) {
    state.isLoadingItems = false
    state.isErrorLoadingItems = true
    state.errorId = payload['cf-ray'] ?? ''

    state.pagination = {
      total: 1,
      totalPages: 1,
      limit: COUNT_CREATIVES_LOAD_PER_PAGE
    }
  }
}

export const fetchFiltersConfigPending = (state) => {
  state.isFiltersLoading = true
}

export const fetchFiltersConfigSuccess = (state, { payload }) => {
  if (!state.isInitialFilters) {
    state.isInitialFilters = true
  }

  state.filtersConfig = payload.transformedFiltersConfig
  state.filtersConfigMap = payload.filtersConfigMap
  state.isFiltersLoading = false

  if (!state.filtersParams) {
    state.filtersParams = payload.initialParams
  }
}

export const fetchFiltersConfigReject = (state) => {
  state.isFiltersLoading = false
}
